import { declareEvent } from "@cloudextend/common/events";

export const appInitialized = declareEvent("Bootstrapping:App Initialized");
